module.exports = __webpack_public_path__ + "img/white-2.7a02cf40.png";